module.exports = __webpack_public_path__ + "static/media/search.036b2983.png";


//////////////////
// WEBPACK FOOTER
// ./src/assents/search.png
// module id = 304
// module chunks = 0